import axios from '../../api/axios';

// Action types
export const AGENT_TOOLS_REQUEST = 'AGENT_TOOLS_REQUEST';
export const AGENT_TOOLS_SUCCESS = 'AGENT_TOOLS_SUCCESS';
export const AGENT_TOOLS_FAILURE = 'AGENT_TOOLS_FAILURE';

export const GET_AGENT_TOOLS_REQUEST = 'GET_AGENT_TOOLS_REQUEST';
export const GET_AGENT_TOOLS_SUCCESS = 'GET_AGENT_TOOLS_SUCCESS';
export const GET_AGENT_TOOLS_FAILURE = 'GET_AGENT_TOOLS_FAILURE';

export const UPDATE_AGENT_TOOLS_REQUEST = 'UPDATE_AGENT_TOOLS_REQUEST';
export const UPDATE_AGENT_TOOLS_SUCCESS = 'UPDATE_AGENT_TOOLS_SUCCESS';
export const UPDATE_AGENT_TOOLS_FAILURE = 'UPDATE_AGENT_TOOLS_FAILURE';

// Action creators

// GET: agent/toolList
export const getToolList = () => async (dispatch) => {
  try {
    dispatch({ type: AGENT_TOOLS_REQUEST });
    
    const response = await axios.get('agent/toolList');
    
    dispatch({
      type: AGENT_TOOLS_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: AGENT_TOOLS_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

// POST: agent/getAgentTools
export const getAgentTools = (userId, type = 'simpleprompt') => async (dispatch) => {
  try {
    dispatch({ type: GET_AGENT_TOOLS_REQUEST });
    
    const response = await axios.post('agent/getAgentTools', {
      userId,
      type
    });
    
    dispatch({
      type: GET_AGENT_TOOLS_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: GET_AGENT_TOOLS_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

// POST: agent/updateAgentTools
export const updateAgentTools = (userId, toolIds) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_AGENT_TOOLS_REQUEST });
    
    const response = await axios.post('agent/updateAgentTools', {
      userId,
      toolIds
    });
    
    dispatch({
      type: UPDATE_AGENT_TOOLS_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: UPDATE_AGENT_TOOLS_FAILURE,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};
